import { CustomSectionContentType } from "@types";
import { HeadingIds } from "@constants";
const isCertificationEmpty = (cert) => !cert.vendor &&
    !cert.name &&
    !cert.dateOfIssue &&
    !cert.expirationDate &&
    !cert.publicLink &&
    !cert.isTermless;
// TODO add tests
export const isCustomSectionEmpty = (cv) => cv.customSectionsDisplay.some(({ header, bodyContentType, content: { bulletPoints, text }, isHidden }) => {
    if (isHidden) {
        return false;
    }
    const isTextAreaSection = bodyContentType === CustomSectionContentType.Text;
    const isBulletsSection = bodyContentType === CustomSectionContentType.BulletPoints;
    const isHeaderEmpty = !header.trim();
    const isBodyEmpty = isTextAreaSection ? !(text === null || text === void 0 ? void 0 : text.trim()) : false;
    const areBulletsEmpty = isBulletsSection
        ? !!(bulletPoints === null || bulletPoints === void 0 ? void 0 : bulletPoints.some(({ value }) => !value.trim()))
        : false;
    const isContentEmpty = isBodyEmpty || areBulletsEmpty;
    return isHeaderEmpty || isContentEmpty;
});
// TODO add tests
export const isEmptyDate = (clearData) => {
    return Boolean(clearData.professionalExperienceDisplay.find((p) => p.startDate === null || p.startDate === undefined || p.endDate === undefined));
};
// TODO add tests
export const isWrongDate = (clearData) => {
    return Boolean(clearData.professionalExperienceDisplay.find((p) => p.endDate !== null && new Date(p.endDate) < new Date(p.startDate)));
};
export const hasInvalidCertificationDates = (clearData) => {
    return clearData.certificationsNewDisplay.some((cert) => !isCertificationEmpty(cert) && cert.dateOfIssue === undefined);
};
export const hasEmptyCertificationVendor = (clearData) => {
    return clearData.certificationsNewDisplay.some((cert) => !isCertificationEmpty(cert) && !cert.vendor.trim());
};
export const hasEmptyCertificationName = (clearData) => {
    return clearData.certificationsNewDisplay.some((cert) => !isCertificationEmpty(cert) && !cert.name.trim());
};
export const hasInvalidCertificationExpiration = (clearData) => {
    return clearData.certificationsNewDisplay.some((cert) => !isCertificationEmpty(cert) && !cert.isTermless && !cert.expirationDate);
};
/**
 * Detects which section has the first validation error and returns its HeadingId
 * Returns null if no errors found
 */
export const getFirstErrorSectionId = (clearData, hasLanguageErrors = false, hasAIToolsErrors = false) => {
    if (isEmptyDate(clearData) || isWrongDate(clearData)) {
        return HeadingIds.ProfessionalExperience;
    }
    if (hasInvalidCertificationDates(clearData)) {
        return HeadingIds.CertificationsNew;
    }
    if (hasEmptyCertificationVendor(clearData)) {
        return HeadingIds.CertificationsNew;
    }
    if (hasEmptyCertificationName(clearData)) {
        return HeadingIds.CertificationsNew;
    }
    if (hasInvalidCertificationExpiration(clearData)) {
        return HeadingIds.CertificationsNew;
    }
    if (isCustomSectionEmpty(clearData)) {
        return HeadingIds.PersonalStrengths; // Custom sections appear after this
    }
    if (hasLanguageErrors) {
        return HeadingIds.LanguageSkills;
    }
    if (hasAIToolsErrors) {
        return HeadingIds.AITools;
    }
    return null;
};
/**
 * Scrolls to the section with the first validation error
 */
export const scrollToFirstErrorSection = (sectionId) => {
    if (!sectionId)
        return;
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
